// 单规格列表
export default {
    heard_title: "Item Order List",
    heard_btn: "Create single item order",
    heard_btn2: "Create a reserved order",

    tb_editPlayer: "Edit Player",
    tb_close: "Close",
    tb_print: "Print receipt",
    // 关闭订单
    dt_closeOrder: "Close order",
    dp_memo: "Please enter a remark",
    // 编辑选手弹出框
    dt_editPlayer: "Add Player",
    d_date: "Date session",
    d_project: "Project",
    d_playerName: "Player",
    // 未完成提示框
    dt_noSuccess: "Not completed",
    dt_message:
        "There are still players who have not entered, do you confirm that the addition is complete",
    // 打印提示
    dt_noPlayer: "Not finished",
    dt_message2: "There are players who have not entered, whether to print",
    // 退款相关
    confirm_title:
        "This operation will be refunded directly to the account, do you want to continue?",
    sm_refundSubmit: "Refund submitted successfully",
    em_refundSubmit: "Error submitting refund",
    im_refundSubmit: "Refund cancelled",
    // 打印
    sm_print: "Print successful",
    em_print: "Print failed"
};
